import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isMobile: null,
    tabIndex:'1'
  },
  mutations: {},
  actions: {},
  modules: {}
});
